import { FlexContainer, Text, Banner } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useScreen from 'Hooks/useScreen';
import { useTranslation } from 'Hooks/useTranslation';
import FormContainer from 'Components/UI/FormContainer';
import ContentContainer from 'Components/UI/ContentContainer';
import { openLinkInNewTab } from 'Utils/links';
import { ScreenPropsType } from 'Types/common';
import ValidationSubmit from '../ValidationSubmit';
import DynamicForm from '../DynamicForm';
import Heading from '../Heading';

const EditScreen = ({ screenName }: ScreenPropsType): JSX.Element => {
  const { t } = useTranslation(locizeNS.VALIDATIONS);

  const { screen, onNextScreen, onPrevScreen, renderForm, yayoyakis, onReloadYayos } =
    useScreen(screenName);
  const { bannerData, header, subheader } = renderForm;
  return (
    <ContentContainer testID="edit-section">
      <FormContainer>
        <FlexContainer direction="column" gap="dimension_32">
          <Heading title={header} />
          {subheader && (
            <Text color="grey" size="S_M_S">
              {subheader}
            </Text>
          )}
          {bannerData && (
            <Banner
              id="banner-flow-id"
              label={bannerData?.body}
              mode="cold"
              hasIcon
              buttonLabel={t('Contextual.Label')}
              position="vertically"
              layout="embed"
              {...bannerData}
              onClick={() => openLinkInNewTab(bannerData?.helpButtonUrl)}
            />
          )}
          <FlexContainer direction="column" gap="dimension_16">
            <DynamicForm yayoyakis={yayoyakis} onReloadYayos={onReloadYayos} />
          </FlexContainer>
        </FlexContainer>
      </FormContainer>
      <ValidationSubmit
        testID="btnSubmit"
        disabled={!screen.isDataValid()}
        onNextScreen={onNextScreen}
        onPrevScreen={onPrevScreen}
        isTrackForm
        screen={screen}
        data={yayoyakis}
      />
    </ContentContainer>
  );
};

export default EditScreen;
